const bottomArrowIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
    <path
      d="M12.28 0.966553L7.9333 5.31322C7.41997 5.82655 6.57997 5.82655 6.06664 5.31322L1.71997 0.966553"
      stroke="#595A61"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const prevIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.005 10.9951L13.598 6.40205C13.6896 6.3086 13.7988 6.23422 13.9193 6.18324C14.0398 6.13225 14.1692 6.10565 14.3001 6.10499C14.4309 6.10433 14.5606 6.12962 14.6816 6.17939C14.8026 6.22915 14.9126 6.30242 15.0051 6.39494C15.0976 6.48747 15.1709 6.59742 15.2207 6.71844C15.2704 6.83945 15.2957 6.96913 15.2951 7.09998C15.2944 7.23083 15.2678 7.36025 15.2168 7.48076C15.1658 7.60126 15.0915 7.71047 14.998 7.80205L11.098 11.7021L14.998 15.6021C15.1806 15.7883 15.2822 16.0392 15.2809 16.3C15.2796 16.5608 15.1754 16.8106 14.991 16.995C14.8065 17.1795 14.5568 17.2837 14.2959 17.285C14.0351 17.2863 13.7843 17.1846 13.598 17.0021L9.005 12.4101C8.81753 12.2225 8.71221 11.9682 8.71221 11.7031C8.71221 11.4379 8.81753 11.1836 9.005 10.9961V10.9951Z"
      fill="#495057"
    />
  </svg>
);
const nextIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.995 10.9949C15.1825 11.1825 15.2878 11.4368 15.2878 11.7019C15.2878 11.9671 15.1825 12.2214 14.995 12.4089L10.402 17.0019C10.2157 17.1845 9.96491 17.2862 9.70409 17.2849C9.44326 17.2835 9.19349 17.1793 9.00905 16.9949C8.82461 16.8105 8.72042 16.5607 8.7191 16.2999C8.71778 16.039 8.81945 15.7882 9.00201 15.6019L12.902 11.7019L9.00201 7.80195C8.81945 7.61566 8.71778 7.36485 8.7191 7.10402C8.72042 6.84319 8.82461 6.59342 9.00905 6.40898C9.19349 6.22455 9.44326 6.12035 9.70409 6.11903C9.96491 6.11771 10.2157 6.21938 10.402 6.40195L14.995 10.9949Z"
      fill="#495057"
    />
  </svg>
);

const SVG = {
  bottomArrowIcon,
  prevIcon,
  nextIcon,
};

export default SVG;


export const PaymentTabsSvg = () => {
  return (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 8.63043V10.5435C12 10.7972 11.8946 11.0405 11.7071 11.2198C11.5196 11.3992 11.2652 11.5 11 11.5H6.25M10 2.8913V0.5H3.5C1.84315 0.5 0.5 1.78475 0.5 3.36957V6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13 5.76086H9.5C9.22386 5.76086 9 5.97499 9 6.23913V8.15217C9 8.4163 9.22386 8.63043 9.5 8.63043H13C13.2761 8.63043 13.5 8.4163 13.5 8.15217V6.23913C13.5 5.97499 13.2761 5.76086 13 5.76086Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 5.76088V3.84783C12 3.59415 11.8946 3.35085 11.7071 3.17147C11.5196 2.99209 11.2652 2.89131 11 2.89131H10H3.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3.83105 6.71739L4.75824 7.60427L3.83105 8.49115" stroke="white" stroke-width="1.03845" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M0.678589 8.66864V7.95914C0.678589 7.86505 0.717663 7.77482 0.787216 7.70829C0.856769 7.64176 0.951102 7.60439 1.04946 7.60439H4.75822" stroke="white" stroke-width="1.03845" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M2.3476 11.3292L1.42041 10.4423L2.3476 9.55544" stroke="white" stroke-width="1.03845" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.50004 9.37813V10.0876C5.50004 10.1817 5.46097 10.2719 5.39142 10.3385C5.32186 10.405 5.22753 10.4424 5.12917 10.4424H1.42041" stroke="white" stroke-width="1.03845" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export const PaymentStatusreceived = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 1L1 15" stroke="#04844B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.497 15H1V5.97194" stroke="#04844B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
}

export const PaymentStatusWaiting= () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 3.5V7.5L9.6 8.8" stroke="#FFA800" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.3261 8.5C12.6489 11.3667 10.0736 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C9.50772 0.5 11.6838 1.92011 12.7678 4" stroke="#FFA800" stroke-linecap="round"/>
      <path d="M13.5 2V4.5H11" stroke="#FFA800" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

  );
}

export const PaymentStatusUnopened = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.5 1.75H1.5C0.947715 1.75 0.5 2.19772 0.5 2.75V11.25C0.5 11.8023 0.947715 12.25 1.5 12.25H12.5C13.0523 12.25 13.5 11.8023 13.5 11.25V2.75C13.5 2.19772 13.0523 1.75 12.5 1.75Z" stroke="#595A61" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M0.5 3L6.36 6.52424C6.53969 6.62973 6.76615 6.6875 7 6.6875C7.23385 6.6875 7.46031 6.62973 7.64 6.52424L13.5 3" stroke="#595A61" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  );
};

export const PaymentStatusProfileShared = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.81234 11.0005L7.99033 13.1685C8.12396 13.3054 8.29104 13.4051 8.47503 13.4577C8.65902 13.5103 8.85355 13.5139 9.03937 13.4682C9.22635 13.4247 9.399 13.3339 9.54072 13.2044C9.68245 13.0749 9.78848 12.9112 9.84862 12.7289L13.4253 2.00876C13.5 1.8079 13.5154 1.58983 13.4697 1.38047C13.424 1.1711 13.3192 0.979261 13.1677 0.827739C13.0162 0.676216 12.8243 0.571388 12.615 0.525714C12.4056 0.48004 12.1875 0.495441 11.9867 0.570087L1.26653 4.14679C1.07795 4.2112 0.909996 4.32481 0.780022 4.47586C0.650048 4.62691 0.562769 4.80993 0.527207 5.006C0.4905 5.18433 0.498671 5.36898 0.550987 5.54337C0.603303 5.71775 0.698124 5.87641 0.826931 6.00508L3.56441 8.74256L3.47449 12.2094L5.81234 11.0005Z" stroke="#6F36BC" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.1057 0.789902L3.56445 8.74258" stroke="#6F36BC" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
)
};